export const SAGE50_VENUE_CONFIRM_COUNT = 40

export const shouldConfirmSage50Size = count =>
  Number(count) > SAGE50_VENUE_CONFIRM_COUNT

export const sage50LargeGroupQuestion = count =>
  `This Sage 50 export has ${count} venues. Generate it now?`

export const sage50ExportBody = (venueIds, start, end) => ({
  venueIds,
  start,
  end,
})

export const sage50LeftOutSentence = venues => {
  const count = (venues || []).length
  if (count === 0) return ''
  if (count === 1) {
    return '1 venue has no Sage venue code, so it was left out of this file. The other venues were exported.'
  }
  return `${count} venues have no Sage venue code, so they were left out of this file. The other venues were exported.`
}

export const sage50VenuesForFile = (venueIds, venues) => {
  const byId = new Map((venues || []).map(venue => [String(venue?._id), venue]))
  const selected = (venueIds || [])
    .map(id => byId.get(String(id)))
    .filter(Boolean)
  const inFile = selected.filter(venue =>
    String(venue.sageVenueCode || '').trim(),
  )
  const leftOut = selected.filter(
    venue => !String(venue.sageVenueCode || '').trim(),
  )
  return { inFile, leftOut }
}

export const sage50BoxVenueIds = (venueIds, venues) =>
  sage50VenuesForFile(venueIds, venues).inFile.map(venue => venue._id)

export const sage50FileNote = ({ inFile, leftOut } = {}) => {
  const count = (inFile || []).length
  const noun = count === 1 ? 'venue' : 'venues'
  const countLine = `${count} ${noun} will be in this file.`
  const names = (leftOut || []).map(venue => venue.title).filter(Boolean)
  if (!names.length) return countLine
  if (names.length === 1) {
    return `${countLine} ${names[0]} has no Sage venue code, so that venue is left out.`
  }
  return `${countLine} ${names.join(
    ', ',
  )} have no Sage venue code, so those venues are left out.`
}

export const sage50ExportFilename = (exportedCount, timestamp) =>
  `sage50-export_${exportedCount}-venues_${timestamp}.csv`

export const SAGE50_LEFT_OUT_TITLE = 'Some venues were left out'
export const SAGE50_BLOCKED_TITLE = 'Missing Sage Venue Codes'
